import { SxProps, Theme } from '@mui/material';

export const useStyles = (theme: Theme): { [key: string]: SxProps<Theme> } => ({
  topBlockBox: {
    backgroundImage:
      'url(city-background-desktop.jpeg),linear-gradient(180deg,rgba(10,10,10,0.73) 0%,rgba(10,10,10,0.73) 100%)',
    backgroundSize: 'cover',
    backgroundPosition: 'bottom',
    backgroundBlendMode: 'soft-light',
    height: '800px',
    pt: '24px',
    px: '10%',

    [theme.breakpoints.between('md', 'lg')]: {
      height: '700px',
    },

    [theme.breakpoints.between('sm', 'md')]: {
      pt: '14px',
      px: '20px',
      height: '700px',
      backgroundImage:
        'url(city-background-mobile.jpeg),linear-gradient(180deg,rgba(10,10,10,0.73) 0%,rgba(10,10,10,0.73) 100%)',
    },

    [theme.breakpoints.down('sm')]: {
      pt: '14px',
      px: '20px',
      height: '680px',
    },
  },

  topBlockContent: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'right',
    maxWidth: '1152px',
    mx: 'auto',
  },

  topBlockImage: {
    position: 'absolute',
    top: '160px',
    right: '0px',
    height: '640px',

    [theme.breakpoints.between('lg', 1360)]: {
      top: '300px',
      height: '500px',
    },

    [theme.breakpoints.between('md', 'lg')]: {
      top: '300px',
      height: '400px',
    },

    [theme.breakpoints.between('sm', 'md')]: {
      top: '400px',
      height: '300px',
    },

    [theme.breakpoints.between('sm', 650)]: {
      top: '480px',
      height: '220px',
    },

    [theme.breakpoints.down('sm')]: {
      top: '496px',
      height: '185px',
      width: '231px',
    },
  },

  topBlockLogo: {
    width: '177.5px',
    height: '32px',
    backgroundColor: 'common.white',

    [theme.breakpoints.down('md')]: {
      width: '40px',
      height: '40px',
      backgroundColor: 'common.white',
    },
  },

  topBlockTextBox: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    mt: '10%',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      mt: '140px',
      ml: '0px',
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      alignItems: 'center',
    },
  },

  logo: {
    position: 'relative',
    width: '335px',
    height: '127px',

    [theme.breakpoints.down('sm')]: {
      width: '285px',
      height: '107px',
    },
  },

  topBlockButton: {
    color: 'grey.0',
    mr: '20px',
  },

  topBlockPurpleText: {
    color: 'primary.dark',
  },

  topBlockWhiteText: {
    color: 'white',
  },

  topBlockText: {
    color: 'white',
    maxWidth: '550px',
    mt: '40px',
  },

  topBlockButtonStart: {
    mt: '40px',
    zIndex: 2,
  },

  link: {
    color: 'white',
    '&:hover': {
      textDecoration: 'none',
      color: 'white',
    },
  },
});
